module.exports = __webpack_public_path__ + "img/race-so-far_lg.jpg";